// extracted by mini-css-extract-plugin
export default {"loader":"Zddbs","bodyWithTable":"tzI7U"};